import React, { type HTMLAttributes } from 'react';

import {
  Container,
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';
import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { ParagraphUSP as Type } from '../../../types/uncinc_profile/paragraphs';
import { ButtonWrapper, ParagraphsRenderer } from '../../../components';

import './style.scss';

interface ParagraphUSPProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphUSP: React.FC<ParagraphUSPProps> = ({
  id,
  entity,
}) => {
  const paragraphUSP = entity.toJS();

  const title = paragraphUSP.field_title[0]?.value;
  const body = paragraphUSP.field_body[0].processed;
  const paragraphs = paragraphUSP.field_paragraphs;
  const link = paragraphUSP.field_link[0];
  const linkTitle = link?.title;
  const linkUrl = link?.alias || link?.uri;
  const secondaryLink = paragraphUSP.field_link_secondary[0];
  const secondaryLinkTitle = secondaryLink?.title;
  const secondaryLinkUrl = secondaryLink?.alias || secondaryLink?.uri;

  return (
    <div id={id} className="Paragraph ParagraphUSP">
      <Container>
        <div className="row">

          {(body || title) && (
            <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
              <div className="ParagraphUSP__content">
                {title && (
                  <h2 className="ParagraphUSP__title">{title}</h2>
                )}
                {body && (
                  <WysiwygField className="ParagraphUSP__body" html={body} />
                )}
              </div>
            </div>
          )}

          <ParagraphsRenderer className="ParagraphUSP__subparagraphs" paragraphs={paragraphs} />
          <div className="col-12">
            {(linkUrl || secondaryLinkUrl) && (
              <div className="ParagraphUSP__links">
                {linkUrl && (
                  <ButtonWrapper
                    href={linkUrl}
                  >
                    {linkTitle}
                  </ButtonWrapper>
                )}

                {secondaryLinkUrl && (
                  <ButtonWrapper
                    type="secondary"
                    href={secondaryLinkUrl}
                  >
                    {secondaryLinkTitle}
                  </ButtonWrapper>
                )}

              </div>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

export default ParagraphUSP;
